exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n* {\n    margin: 0;\n    padding: 0;\n}\nbody {\n    font: 14px Arial, Helvetica, sans-serif;\n    line-height: 1;\n}\n", "", {"version":3,"sources":["/home/ferry/ONLINE_SERVICE/other/ferry/task_workspace/baidu/ps-aladdin/med-health-pc/src/App.vue"],"names":[],"mappings":";AACA;IACI,UAAU;IACV,WAAW;CACd;AACD;IACI,wCAAwC;IACxC,eAAe;CAClB","file":"App.vue","sourcesContent":["\n* {\n    margin: 0;\n    padding: 0;\n}\nbody {\n    font: 14px Arial, Helvetica, sans-serif;\n    line-height: 1;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07c1d2fc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = DmLU
// module chunks = 1